export default __webpack_public_path__ + "static/media/MegaGS.3fba42b0.jpg";